import { useAuth } from "react-oidc-context";

const AuthGate = ({children}) => {
    const auth = useAuth();
    if(auth.isLoading) {
        return <div>Authenticating...</div>
    }

    return children;
}

export default AuthGate